import React from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// minified version is also included
// import 'react-toastify/dist/ReactToastify.min.css';

export const Toaster = (type: string, msg: string) => {
    toast.dismiss();
    switch (type) {
      case toast.TYPE.SUCCESS:
        return toast.success(msg);
      case toast.TYPE.ERROR:
        return toast.error(msg);
      case toast.TYPE.WARNING:
        return toast.warn(msg);
      case toast.TYPE.INFO:
        return toast.info(msg);
      case toast.TYPE.DEFAULT:
        return toast(msg);
    }

    return <div></div>;

  // return <div>{notify()}</div>;
};
